// Сезон Gold (Economy v0.1, п. 27–33): фиксированный пул токена делится пропорционально вложенному Gold.
// Фаза 3 — симуляция: награда считается и показывается, но токен не выдаётся.

/** GET /api/seasons/current */
export interface SeasonDto {
  number: number;
  startsAt: string;
  endsAt: string;
  tokenPool: number;
  totalCommittedGold: number;
  participants: number;
  /** токен не выдаётся — только расчёт */
  simulated: boolean;
}

/** GET /api/seasons/current/user */
export interface SeasonUserDto {
  /** null — сезон ещё не начался (создаёт владелец) */
  season: SeasonDto | null;
  availableGold: number;
  userCommittedGold: number;
  /** оценка по текущему курсу: пул × вложено / всего (до конца сезона меняется) */
  estimatedTokenReward: number;
  /** итог прошлого сезона игрока (если участвовал) */
  lastSettlement: { season: number; committedGold: number; tokenAmount: string; simulated: boolean } | null;
}

/** Оценка доли пула */
export const estimateReward = (pool: number, user: number, total: number): number =>
  total > 0 ? Math.floor((pool * user * 1_000_000) / total) / 1_000_000 : 0;
